// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"ab9be7ed","28":"f5049084","172":"57e4879e","175":"22708b79","231":"c31e6b48","279":"f92eb946","296":"4e902d8a","399":"2c494a3f","488":"c92f8942","498":"6f75f64a","780":"117e3264","835":"9c2cf06c","945":"5b3538ad"}[chunkId] + ".chunk.js";
};